import { useContext } from 'react';

/* eslint-disable @next/next/no-css-tags */
/* eslint-disable @next/next/no-img-element */
import Head from 'next/head';
import Script from 'next/script';

import { Link } from 'libs/router/Link';

import { ContentContext } from 'context/ContentContext';

import { style } from './MexicoPage.style';

const MexicoPage = () => {
  const { secondaryNavigation } = useContext(ContentContext);

  return (
    <>
      <Head>
        <style dangerouslySetInnerHTML={{ __html: style }} />

        <link rel="stylesheet" href="/proxy/lead/css/presentation-popup.css" />
      </Head>

      <Script src="/js/components.min.js" />
      <Script src="/js/business-validation.js" />
      <Script src="/js/book-a-demo.js" />
      <Script src="/js/product.js" />
      <Script src="/js/scripts.min.js" />

      <div className="search">
        <div className="wrap">
          <form id="form-mexico" action="#no-url" method="get">
            <div className="search-flex">
              <div className="big-search-input">
                <i className="big-loop">
                  <svg viewBox="0 0 47.4 47.4">
                    <path d="M20 40c4.8 0 9.4-1.7 13-4.9l11.7 11.7c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1L35.2 33c6.8-7.9 6.4-19.7-1-27.2C30.4 2.1 25.4 0 20 0S9.6 2.1 5.9 5.9C2.1 9.6 0 14.7 0 20s2.1 10.4 5.9 14.2C9.6 37.9 14.7 40 20 40zM8 8c3.2-3.2 7.5-5 12-5s8.8 1.8 12 5c6.6 6.6 6.6 17.4 0 24.1-3.2 3.2-7.5 5-12 5s-8.8-1.8-12-5c-3.2-3.2-5-7.5-5-12C3 15.5 4.8 11.2 8 8z" />
                  </svg>
                </i>
                <input type="text" name="query" id="search-field" placeholder="Busque" />
                <i className="big-close">
                  <svg width="13.97" height="13.969" viewBox="0 0 13.97 13.969">
                    <path d="M13.75 1.24l-5.79 5.8 5.65 5.651a.75.75 0 0 1 0 1.056.748.748 0 0 1-1.06 0L6.9 8.097l-5.5 5.5A.749.749 0 0 1 .34 12.54l5.5-5.5L.19 1.39A.748.748 0 0 1 1.25.333l5.65 5.65 5.8-5.8a.745.745 0 1 1 1.05 1.057z" />
                  </svg>
                </i>
              </div>
              <button type="submit" className="btn-blue-grad">
                Busque
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="product-head full-bg" style={{ backgroundImage: 'url(/proxy/lead/upload/product/540.jpg);' }}>
        <canvas id="constellation" width="1920" height="950"></canvas>
        <div className="wrapper">
          <div>
            <h1>Base de datos de empresas en Mexico</h1>
            <h3></h3>

            {secondaryNavigation.book_demo?.slug && (
              <Link route={secondaryNavigation.book_demo.slug} className="btn-info btn-lg">
                SOLICITE UNA DEMOSTRACIÓN
              </Link>
            )}
          </div>
          <div className="row four-one">
            <div className="col-sm-3">
              <div className="zh-svg-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="65.031" height="72" viewBox="0 0 65.031 72">
                  <path d="M57.052 7.339h-5.774V4.181a4.205 4.205 0 0 0-8.409 0v3.158H24.125V4.181a4.207 4.207 0 0 0-8.413 0v3.158H8.957c-4.935 0-8.95 4.4-8.95 9.818v45.024A9.857 9.857 0 0 0 9.877 72H55.15a9.857 9.857 0 0 0 9.872-9.819V17.157c.003-5.414-3.576-9.818-7.97-9.818zM45.063 4.181a2.011 2.011 0 0 1 4.021 0v8.308a2.011 2.011 0 0 1-4.021 0V4.181zm-27.16 0a2.013 2.013 0 0 1 4.025 0v8.308a2.007 2.007 0 0 1-2.009 2 2.008 2.008 0 0 1-2.012-2V4.181zm-8.949 5.34h6.755v2.968a4.207 4.207 0 0 0 8.413 0V9.521h18.747v2.968a4.205 4.205 0 0 0 8.409 0V9.521h5.774c3.186 0 5.776 3.427 5.776 7.636v6.612H2.198v-6.612c0-4.209 3.027-7.636 6.756-7.636zm46.2 60.3H9.877a7.667 7.667 0 0 1-7.679-7.636v-36.23h60.627v36.23a7.667 7.667 0 0 1-7.675 7.632zm3.147-29.057a1.091 1.091 0 1 0 0-2.182h-7.848v-7.27a1.1 1.1 0 0 0-2.194 0v7.27h-14.65v-7.27a1.1 1.1 0 0 0-2.194 0v7.27H16.769v-7.27a1.1 1.1 0 0 0-2.194 0v7.27h-7.85a1.091 1.091 0 1 0 0 2.182h7.85v13.761h-7.85a1.091 1.091 0 1 0 0 2.181h7.85v7.275a1.1 1.1 0 0 0 2.194 0V56.7h14.646v7.275a1.1 1.1 0 0 0 2.194 0V56.7h14.646v7.275a1.1 1.1 0 0 0 2.194 0V56.7h7.848a1.091 1.091 0 1 0 0-2.181h-7.848V40.76h7.848zM16.773 54.525V40.76h14.642v13.761H16.769zm31.486 0h-14.65V40.76h14.646v13.761z" />
                </svg>
              </div>
              <div className="four-one-content">
                <h4>
                  12 Meses <br /> Suscripción
                </h4>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="zh-svg-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="78.031" height="72" viewBox="0 0 78.031 72">
                  <path d="M55.138 72H8.064a8.08 8.08 0 0 1-8.072-8.068V8.065A8.079 8.079 0 0 1 8.064 0h47.074a8.079 8.079 0 0 1 8.073 8.066v12.469a1.092 1.092 0 0 1-2.184 0V8.065a5.894 5.894 0 0 0-5.889-5.884H8.064a5.894 5.894 0 0 0-5.889 5.884v55.867a5.894 5.894 0 0 0 5.889 5.885h47.074a5.894 5.894 0 0 0 5.893-5.885v-12.67a1.092 1.092 0 0 1 2.184 0v12.67A8.08 8.08 0 0 1 55.138 72zm-2.456-46.547h-51.6a1.091 1.091 0 1 1 0-2.181h51.6a1.091 1.091 0 1 1 0 2.181zm0 23.273h-51.6a1.091 1.091 0 1 1 0-2.182h51.6a1.091 1.091 0 1 1 0 2.182zm-40-33.5a2.144 2.144 0 1 1 2.146-2.143 2.147 2.147 0 0 1-2.15 2.138zm-.038-2.143a.037.037 0 0 0 .038.037zm10.578 2.143a2.144 2.144 0 1 1 2.147-2.143 2.147 2.147 0 0 1-2.151 2.138zm-.037-2.143a.036.036 0 0 0 .037.037zM62.118 51.9a15.9 15.9 0 1 1 15.913-15.893A15.922 15.922 0 0 1 62.118 51.9zm0-29.613a13.716 13.716 0 1 0 13.728 13.718 13.738 13.738 0 0 0-13.728-13.716zM69.131 37.1a1.09 1.09 0 0 1-1.092-1.09 5.92 5.92 0 0 0-11.116-2.831 1.092 1.092 0 0 1-1.917-1.046 8.1 8.1 0 0 1 15.217 3.877 1.091 1.091 0 0 1-1.092 1.09zm0 0a1.091 1.091 0 0 1-.595-.176l-2.562-1.669a1.091 1.091 0 1 1 1.192-1.828l1.648 1.074 1.126-1.723a1.091 1.091 0 0 1 1.827 1.193l-1.721 2.636a1.09 1.09 0 0 1-.915.493zm-7.011 7.006a8.107 8.107 0 0 1-8.1-8.1 1.092 1.092 0 0 1 2.183 0 5.922 5.922 0 0 0 11.051 2.952 1.092 1.092 0 0 1 1.892 1.09 8.134 8.134 0 0 1-7.028 4.052zm-8.735-4.369a1.09 1.09 0 0 1-.912-1.687l1.722-2.637a1.1 1.1 0 0 1 1.51-.318l2.562 1.67a1.091 1.091 0 1 1-1.192 1.828l-1.648-1.074-1.127 1.724a1.089 1.089 0 0 1-.917.489z" />
                </svg>
              </div>
              <div className="four-one-content">
                <h4>
                  Diario <br /> diarias
                </h4>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="zh-svg-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="78" height="66" viewBox="0 0 78 66">
                  <path d="M68.725 2.325H9.271a1.159 1.159 0 1 1 0-2.317h59.454a1.159 1.159 0 1 1 0 2.317zm3.369 63.681H5.901a5.854 5.854 0 0 1-5.9-5.8V13.247a5.855 5.855 0 0 1 5.9-5.8h66.192a5.855 5.855 0 0 1 5.9 5.8v46.961a5.854 5.854 0 0 1-5.9 5.795zM5.902 9.773a3.513 3.513 0 0 0-3.539 3.477v46.961a3.512 3.512 0 0 0 3.539 3.477h66.192a3.512 3.512 0 0 0 3.539-3.477V13.247a3.512 3.512 0 0 0-3.539-3.477H5.901zm53.365 0H18.725a1.16 1.16 0 1 1 0-2.319h40.537a1.16 1.16 0 1 1 .004 2.316zM40.325 54.586H12.572a1.169 1.169 0 0 1-1.18-1.158v-3.1a5.053 5.053 0 0 1 2.931-4.55l6.249-3.773a8.857 8.857 0 0 1-3.37-6.575l-.237-6.111a8.546 8.546 0 0 1 8.66-8.434h1.649a8.539 8.539 0 0 1 8.662 8.39l-.239 6.155a8.857 8.857 0 0 1-3.378 6.581l6.315 3.8a5.045 5.045 0 0 1 2.874 4.522v3.1a1.169 1.169 0 0 1-1.183 1.153zm-26.576-2.318h25.4v-1.943a2.723 2.723 0 0 0-1.583-2.456 1.02 1.02 0 0 1-.113-.06l-7.963-4.79a1.148 1.148 0 0 1 .09-2.024 6.623 6.623 0 0 0 3.76-5.659l.239-6.11a6.191 6.191 0 0 0-6.3-6.029h-1.654a6.2 6.2 0 0 0-6.3 6.072l.236 6.067a6.635 6.635 0 0 0 3.75 5.655 1.149 1.149 0 0 1 .088 2.024l-7.953 4.793a2.793 2.793 0 0 0-1.692 2.514v1.944zm51.839-23.67H51.017a1.159 1.159 0 1 1 0-2.317h14.574a1.159 1.159 0 1 1 0 2.317zm0 10.292H51.017a1.159 1.159 0 1 1 0-2.317h14.574a1.159 1.159 0 1 1 0 2.317zm0 10.3H51.017a1.159 1.159 0 1 1 0-2.317h14.574a1.159 1.159 0 1 1 0 2.313z" />
                </svg>
              </div>
              <div className="four-one-content">
                <h4>
                  Cambio de trabajo <br /> Alertas de
                </h4>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="zh-svg-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="75" height="64" viewBox="0 0 75 64">
                  <path d="M69.32 0H5.68A5.7 5.7 0 0 0 0 5.715v52.571A5.7 5.7 0 0 0 5.68 64h63.64A5.7 5.7 0 0 0 75 58.286V5.714A5.7 5.7 0 0 0 69.32 0zM5.68 2.286h63.64a3.423 3.423 0 0 1 3.41 3.429V15.5H2.27V5.715a3.423 3.423 0 0 1 3.41-3.43zm63.64 59.428H5.68a3.423 3.423 0 0 1-3.41-3.428v-40.5h70.46v40.5a3.423 3.423 0 0 1-3.41 3.427zm-59.26-50.5h.21a1.143 1.143 0 0 0 0-2.286h-.42a1.053 1.053 0 0 0-1.03 1.144 1.23 1.23 0 0 0 1.24 1.141zm8.31 0h.21a1.143 1.143 0 0 0 0-2.286h-.42a1.053 1.053 0 0 0-1.03 1.144 1.23 1.23 0 0 0 1.24 1.141zm8.31 0h.21a1.143 1.143 0 0 0 0-2.286h-.43a1.059 1.059 0 0 0-1.03 1.144 1.239 1.239 0 0 0 1.25 1.141zm18.63 29.915l-6.67 6.713V28.733a1.14 1.14 0 1 0-2.28 0v19.108l-6.67-6.713a1.136 1.136 0 0 0-1.61 0 1.155 1.155 0 0 0 0 1.617l8.62 8.662a1.088 1.088 0 0 0 .37.247 1.067 1.067 0 0 0 .43.089 1.1 1.1 0 0 0 .43-.089 1.088 1.088 0 0 0 .37-.247l8.62-8.662a1.155 1.155 0 0 0 0-1.617 1.136 1.136 0 0 0-1.61 0z" />
                </svg>
              </div>
              <div className="four-one-content">
                <h4>
                  Datos gratis <br /> Exportar
                </h4>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="zh-svg-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="66" height="74" viewBox="0 0 66 74">
                  <path d="M40.5 20.774a1.036 1.036 0 0 1-.86-.46l-7.5-11.123a1.045 1.045 0 0 1-.17-.786 1.079 1.079 0 0 1 .44-.671L43.46.18a1.041 1.041 0 0 1 1.45.279 1.053 1.053 0 0 1-.28 1.457L34.45 8.88l6.91 10.256a1.044 1.044 0 0 1-.86 1.638zM33 74.003a33.273 33.273 0 0 1-18.45-60.777 1.046 1.046 0 0 1 1.45.283 1.064 1.064 0 0 1-.28 1.458A30.871 30.871 0 1 0 33 9.651a1.05 1.05 0 0 1 0-2.1 33.226 33.226 0 0 1 0 66.452zM17.65 43.535h6.29a9.6 9.6 0 0 0 2.39-.349 4.086 4.086 0 0 0 1.47-.829c.12-.09.23-.178.46-.357a4.12 4.12 0 0 0 1.15-2 6.924 6.924 0 0 0 0-4.286 2.972 2.972 0 0 0-1.15-1.835 4.012 4.012 0 0 0-1.85-1.164 5.626 5.626 0 0 0-2.47-.371H13.41a1.622 1.622 0 0 0 0 3.243h10.53a4.731 4.731 0 0 1 1.48.282 1.753 1.753 0 0 1 .79.456 1.373 1.373 0 0 1 .4.536v.834a2.365 2.365 0 0 1-.23.936 2.841 2.841 0 0 1-.48.76 1.793 1.793 0 0 1-.8.453 3.8 3.8 0 0 1-1.32.284h-6.29c-3.05 0-5.03 1.909-5.03 4.863v5.026h15.41a1.622 1.622 0 0 0 0-3.242H15.61l-.01-1.694c.08-.718.38-1.546 2.05-1.546zm34.73-1.946h-2.2v-8.917a1.571 1.571 0 1 0-3.14 0v8.917h-8.17a1.661 1.661 0 0 1-1.58-1.621v-7.3a1.571 1.571 0 1 0-3.14 0v7.3a4.741 4.741 0 0 0 4.72 4.864h8.17v3.729a1.571 1.571 0 1 0 3.14 0v-3.729h2.2a1.622 1.622 0 0 0 0-3.243z" />
                </svg>
              </div>
              <div className="four-one-content">
                <h4>
                  24/7 <br /> Acceso
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="product-content">
        <div className="wrapper">
          <div className="h-tachometer">
            <div className="h-tachometer-count" data-value="1" data-total="2387041" data-size="290">
              <div className="h-tachometer-count-inner">
                <div className="h-tachometer-value">2,387,041</div>
                <span className="h-tachometer-subtitle">COMPAÑÍAS</span>
              </div>
            </div>
          </div>
          <h2>Base de datos de empresas en Mexico</h2>
          <div className="product-content-custom">
            <p>
              Deje que Global Database mejore sus campa&ntilde;as de mercadeo con nuestra informaci&oacute;n empresarial
              de M&eacute;xico. Cuando compre acceso a nuestra base de datos de correos electr&oacute;nicos, usted
              obtiene 181703 perfiles de empleados de la regi&oacute;n, as&iacute; que ya sea si est&aacute; en un
              mercado completamente nuevo o simplemente busca aumentar su canal de ventas, tenemos todo lo que necesita
              en una sola soluci&oacute;n unificada.
            </p>
            <p>
              <em>Nuestra directorio de empresas</em> no solo tiene informaci&oacute;n de contacto actual y precisa de
              los tomadores de decisi&oacute;n en M&eacute;xico, tambi&eacute;n contiene informaci&oacute;n valiosa
              sobre compa&ntilde;&iacute;as que permiten reducir la b&uacute;squeda e incluso calificar los posibles
              clientes antes de a&ntilde;adirlos a su lista de correo. Esto incluye informaci&oacute;n financiera,
              cantidad de empleados, a&ntilde;os de operaci&oacute;n, ubicaciones de oficinas y mucho m&aacute;s,
              proporcion&aacute;ndole una visi&oacute;n general completa de cada compa&ntilde;&iacute;a.
            </p>
            <p>
              &bull; Informaci&oacute;n financiera
              <br />
              &bull; Cantidad de empleados
              <br />
              &bull; A&ntilde;os de operaci&oacute;n
              <br />
              &bull; ejecutivos importantes y altos directivos
              <br />
              &bull; Ubicaciones de oficinas y mucho m&aacute;s, que le proporciona una vista general completa de cada
              empresa.
              <br />
              &nbsp;
            </p>
          </div>
        </div>
        <div className="section-banner">
          <div className="banner-table">
            <table className="b-table active">
              <tbody>
                <tr className="in-shadow ">
                  <th>EMAIL</th>
                  <th>FIRST NAME</th>
                  <th>LAST NAME</th>
                  <th>JOB FUNCTION</th>
                  <th>COMPANY</th>
                  <th>PHONE NUMBER</th>
                </tr>
                <tr className="in-shadow ">
                  <td>AA**@alcorsa.com</td>
                  <td>Armando</td>
                  <td>Alvarado</td>
                  <td>Product Management</td>
                  <td>Alcorsa</td>
                  <td>+52 8*****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>HU**@alcorsa.com</td>
                  <td>Herman</td>
                  <td>Unger</td>
                  <td>Sales and Business Development</td>
                  <td>Alcorsa</td>
                  <td>+52 8*****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>albert******@gairet.com.mx</td>
                  <td>Alberto Rodríguez</td>
                  <td>Tort</td>
                  <td>Sales and Business Development</td>
                  <td>CORPORATIVO GAIRET, S.A. DE C.V.</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>anat****@gairet.com.mx</td>
                  <td>Anatoli</td>
                  <td>Vázquez</td>
                  <td>Sales and Business Development</td>
                  <td>CORPORATIVO GAIRET, S.A. DE C.V.</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>herib*****@hermesmusic.com.mx</td>
                  <td>Heriberto</td>
                  <td>Iturbide</td>
                  <td>Sales and Business Development</td>
                  <td>HERMES MUSIC, S.A. DE C.V.</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>luis.g******@hermesmusic.com.mx</td>
                  <td>Luis Gabriel</td>
                  <td>Buñuelos</td>
                  <td>Purchasing and Procurement</td>
                  <td>HERMES MUSIC, S.A. DE C.V.</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>fs**@vitalis.com.mx</td>
                  <td>Fer</td>
                  <td>Salas</td>
                  <td>Research and Development</td>
                  <td>VITALIS</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>ic**@vitalis.com.mx</td>
                  <td>Irving</td>
                  <td>Caracosa Vargas</td>
                  <td>Consulting</td>
                  <td>VITALIS</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>jg**@vitalis.com.mx</td>
                  <td>Jonathan</td>
                  <td>Gonzalez</td>
                  <td>Operations and Logistics</td>
                  <td>VITALIS</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>ange****@bizcom.com.mx</td>
                  <td>Angelina</td>
                  <td>Garcia</td>
                  <td>Media and Communication</td>
                  <td>COMMERCIAL MEDIA BIZCOM S.A. DE C.V.</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>enri****@bizcom.com.mx</td>
                  <td>Enrique</td>
                  <td>Rountree</td>
                  <td>Media and Communication</td>
                  <td>COMMERCIAL MEDIA BIZCOM S.A. DE C.V.</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>ger***@bizcom.com.mx</td>
                  <td>Germán</td>
                  <td>Reyes</td>
                  <td>Information Technology</td>
                  <td>COMMERCIAL MEDIA BIZCOM S.A. DE C.V.</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>ar**@reduno.com.mx</td>
                  <td>Alfonso</td>
                  <td>Romero Galbraith</td>
                  <td>Human Resources</td>
                  <td>Consorcio Red Uno</td>
                  <td>+526****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>cc**@reduno.com.mx</td>
                  <td>Carlos</td>
                  <td>Cazarez Celaya</td>
                  <td>Information Technology</td>
                  <td>Consorcio Red Uno</td>
                  <td>+526****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>ct**@reduno.com.mx</td>
                  <td>Carlos</td>
                  <td>Toledo Zepeda</td>
                  <td>Consulting</td>
                  <td>Consorcio Red Uno</td>
                  <td>+526****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>ar**@fandeli.com.mx</td>
                  <td>Alejandro</td>
                  <td>Ramirez Anzures</td>
                  <td>Information Technology</td>
                  <td>FANDELI</td>
                  <td>+523****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>cr**@fandeli.com.mx</td>
                  <td>Cesar</td>
                  <td>Romero</td>
                  <td>Marketing</td>
                  <td>FANDELI</td>
                  <td>+523****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>ct**@fandeli.com.mx</td>
                  <td>Claudia Yuria</td>
                  <td>Tinoco Pedroza</td>
                  <td>Information Technology</td>
                  <td>FANDELI</td>
                  <td>+523****</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="banner-overlay banner-overlay-gradient"></div>
          <div className="banner-content banner-white">
            <div className="wrapper">
              <h3 className="banner-content-title-small text-center">
                GLOBAL DATABASE PUEDE PROPORCIONARLE UN DIRECTORIO ACTUALIZADO DE COMPAÑÍAS EN México QUE CONTIENE:
              </h3>
              <div className="tachometers-ul first-tach text-center">
                <div className="tachometer-li">
                  <div
                    className="t-value active"
                    data-size="140"
                    data-value="1"
                    data-total="2387041"
                    data-thickness="10"
                  >
                    <div className="t-value-inner">2,387,041</div>
                  </div>
                  <h6 className="t-title">Total de compañías</h6>
                </div>
                <div className="tachometer-li">
                  <div
                    className="t-value active"
                    data-size="140"
                    data-value="1"
                    data-total="193774"
                    data-thickness="10"
                  >
                    <div className="t-value-inner">193,774</div>
                  </div>
                  <h6 className="t-title">Ejecutivos</h6>
                </div>
                <div className="tachometer-li">
                  <div
                    className="t-value active"
                    data-size="140"
                    data-value="1"
                    data-total="69,049"
                    data-thickness="10"
                  >
                    <div className="t-value-inner">69,049</div>
                  </div>
                  <h6 className="t-title">Correos electrónicos</h6>
                </div>
                <div className="tachometer-li">
                  <div
                    className="t-value active"
                    data-size="140"
                    data-value="1"
                    data-total="278,187"
                    data-thickness="10"
                  >
                    <canvas width="280" height="280" style={{ height: 140, width: 140 }} />
                    <div className="t-value-inner">278,187</div>
                  </div>
                  <h6 className="t-title">Números de teléfono</h6>
                </div>
                <div className="tachometer-li">
                  <div
                    className="t-value active"
                    data-size="140"
                    data-value="1"
                    data-total="2021-06-24"
                    data-thickness="10"
                  >
                    <div className="t-value-inner" style={{ fontSize: '17px' }}>
                      2021-06-24
                    </div>
                  </div>
                  <h6 className="t-title">Última actualización</h6>
                </div>
              </div>
              <div className="buttons-group text-center">
                {secondaryNavigation.free_trial?.slug && (
                  <Link route={secondaryNavigation.free_trial.slug} className="btn-white btn-lg">
                    DESCARGUE UNA MUESTRA
                  </Link>
                )}

                {secondaryNavigation.pricing?.slug && (
                  <Link route={secondaryNavigation.pricing.slug} className="btn-white btn-lg">
                    COMPRAR AHORA
                  </Link>
                )}

                {secondaryNavigation.book_demo?.slug && (
                  <Link route={secondaryNavigation.book_demo.slug} className="btn-white btn-lg">
                    DEMOSTRACIÓN GRATUITA
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper">
          <div className="section-heading">
            <div className="h-icon">
              <img src="/proxy/lead/img/header-icon-industry.png" alt="Listado de industrias Mexicanas" />
            </div>
            <h2>Listado de industrias Mexicanas</h2>
            <p>
              Si necesita comprar informaci&oacute;n de negocios sobre un sector en espec&iacute;fico, Global Database
              es perfecto para eso. Nuestra plataforma en l&iacute;nea proporciona acceso a 181703 registros en 34
              industrias en M&eacute;xico. Estas consisten de todo desde mercadeo a agricultura y finanzas hasta
              energ&iacute;a y gas, as&iacute; que sin importar cu&aacute;l campo est&aacute; dirigi&eacute;ndose,
              podr&aacute; obtener informaci&oacute;n de alta calidad al alcance de sus manos.
            </p>
          </div>
          <div className="section-content">
            <div className="tachometers-ul second-tach text-center">
              <div className="tachometer-li">
                <div className="t-value active" data-size="180" data-value="1" data-total="34" data-thickness="5">
                  <div className="t-value-inner">34</div>
                </div>
                <h6 className="t-title">Número de industrias en México</h6>

                {secondaryNavigation.free_trial?.slug && (
                  <Link route={secondaryNavigation.free_trial.slug} className="btn-blue btn-lg open-sample">
                    DESCARGUE UNA MUESTRA
                  </Link>
                )}
              </div>
              <div className="tachometer-li">
                <div
                  className="t-value active"
                  data-size="180"
                  data-value="1"
                  data-total="5344.2058823529"
                  data-thickness="5"
                >
                  <div className="t-value-inner">5,344</div>
                </div>
                <h6 className="t-title">Compañía promedio por industria</h6>

                {secondaryNavigation.pricing?.slug && (
                  <Link route={secondaryNavigation.pricing.slug} className="btn-blue btn-lg">
                    COMPRAR AHORA
                  </Link>
                )}
              </div>
              <div className="tachometer-li">
                <div
                  className="t-value active"
                  data-size="180"
                  data-value="1"
                  data-total="Chemicals"
                  data-thickness="5"
                >
                  <div className="t-value-inner">Chemicals</div>
                </div>
                <h6 className="t-title">Industria más grande de México</h6>
                {secondaryNavigation.book_demo?.slug && (
                  <Link route={secondaryNavigation.book_demo.slug} className="btn-green btn-lg">
                    DEMOSTRACIÓN GRATUITA
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="gray-bg">
          <div className="wrapper">
            <h2 className="m-b"></h2>
            <div className="section-filters">
              <div>
                <img src="/proxy/lead/img/icon-company-employee.png" alt="PUESTO DE TRABAJO" />
                <span>PUESTO DE TRABAJO</span>
              </div>
              <div>
                <img src="/proxy/lead/img/icon-company-seniority-level.png" alt="NIVEL DE ANTIGÜEDAD" />
                <span>NIVEL DE ANTIGÜEDAD</span>
              </div>
              <div>
                <img src="/proxy/lead/img/icon-company-revenue.png" alt="INGRESOS POR VENTAS" />
                <span>INGRESOS POR VENTAS</span>
              </div>
              <div>
                <img src="/proxy/lead/img/icon-company-size.png" alt="TAMAÑO DE COMPAÑÍA" />
                <span>TAMAÑO DE COMPAÑÍA</span>
              </div>
            </div>
            <h3 className="m-t">Reserve una demostración de 5 minutos</h3>
            <div className="buttons-group">
              {secondaryNavigation.pricing?.slug && (
                <Link route={secondaryNavigation.pricing.slug} className="btn-blue btn-lg">
                  COMPRAR AHORA
                </Link>
              )}

              {secondaryNavigation.book_demo?.slug && (
                <Link route={secondaryNavigation.book_demo.slug} className="btn-green btn-lg">
                  DEMOSTRACIÓN GRATUITA
                </Link>
              )}
            </div>
          </div>
        </div>
        <div className="wrapper">
          <div className="section-heading">
            <div className="h-icon">
              <img src="/proxy/lead/img/header-icon-envelop.png" alt="Emails de empresas Mexicanas" />
            </div>
            <h2>Emails de empresas Mexicanas</h2>
            <p>
              Cuando compra acceso a la lista de correos electr&oacute;nicos de M&eacute;xico de Global Database, no
              solo gana m&aacute;s de 69,049 direcciones de correo electr&oacute;nico directo de la regi&oacute;n, sino
              tambi&eacute;n una gama de herramientas flexibles de filtrado que le permiten crear listas de correo
              bastantes refinadas y dirigidas. Esto es esencial para configurar campa&ntilde;as segmentadas, ya que
              estas tienen una tasa de 14.32% o m&aacute;s que las no segmentadas seg&uacute;n Mailchimp, lo cual hace
              que probablemente logre tener un gran aumento en los ingresos.
            </p>
          </div>
        </div>
        <div className="section-banner">
          <div className="banner-table">
            <table className="b-table active">
              <tbody>
                <tr className="in-shadow ">
                  <th>COMPANY</th>
                  <th>FIRST NAME</th>
                  <th>LAST NAME</th>
                  <th>JOB FUNCTION</th>
                  <th>EMAIL</th>
                  <th>INDUSTRY</th>
                  <th>PHONE NUMBER</th>
                </tr>
                <tr className="in-shadow ">
                  <td>BBVA Bancomer</td>
                  <td>Adrián</td>
                  <td>Otero</td>
                  <td>Finance and Accounting</td>
                  <td>adr***@bbva.com</td>
                  <td>Education &amp; Training</td>
                  <td>+526****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>BBVA Bancomer</td>
                  <td>Alejandro</td>
                  <td>Piña</td>
                  <td>Human Resources</td>
                  <td>a*@bbva.com</td>
                  <td>Education &amp; Training</td>
                  <td>+526****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>BBVA Bancomer</td>
                  <td>Arturo</td>
                  <td>Alcalde</td>
                  <td>Information Technology</td>
                  <td>artu****@bbva.com</td>
                  <td>Education &amp; Training</td>
                  <td>+526****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>BBVA Bancomer</td>
                  <td>César Guillermo</td>
                  <td>Cristiani Arias</td>
                  <td>Information Technology</td>
                  <td>cesa****@bbva.com</td>
                  <td>Education &amp; Training</td>
                  <td>+526****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>BANCO SANTANDER</td>
                  <td>Alejandro</td>
                  <td>Mejía Ruiz</td>
                  <td>Finance and Accounting</td>
                  <td>am**@santander.com.mx</td>
                  <td>Finance &amp; Insurance</td>
                  <td>+526****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>BANCO SANTANDER</td>
                  <td>Alina</td>
                  <td>Treviño</td>
                  <td>Project Management</td>
                  <td>at**@santander.com.mx</td>
                  <td>Finance &amp; Insurance</td>
                  <td>+526****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>CENTRO DE CONECTIVIDAD, S.A. DE C.V.</td>
                  <td>Ana Laura</td>
                  <td>Heredia</td>
                  <td>Purchasing and Procurement</td>
                  <td>lh**@cdcmx.com</td>
                  <td></td>
                  <td>(52) *****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>CENTRO DE CONECTIVIDAD, S.A. DE C.V.</td>
                  <td>Margarita R. de los</td>
                  <td>Santos</td>
                  <td>Finance and Accounting</td>
                  <td>margari*******@cdcmx.com</td>
                  <td></td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>SYCSA - SILOS Y CAMIONES, S.A. DE C.V.</td>
                  <td>Carlos</td>
                  <td>Hernández</td>
                  <td>Sales and Business Development</td>
                  <td>carl****@sycsa.com</td>
                  <td></td>
                  <td>+527****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>SYCSA - SILOS Y CAMIONES, S.A. DE C.V.</td>
                  <td>Eduardo</td>
                  <td>Jaime</td>
                  <td>Sales and Business Development</td>
                  <td>edu***@sycsa.com</td>
                  <td></td>
                  <td>+527****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>SYCSA - SILOS Y CAMIONES, S.A. DE C.V.</td>
                  <td>Miguel Angel</td>
                  <td>Navarrete</td>
                  <td>Sales and Business Development</td>
                  <td>miguel******@sycsa.com</td>
                  <td></td>
                  <td>+527****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>GENEMEX - ANUNCIOS GENERAL NEON DE MEXICO, S.A. DE C.V.</td>
                  <td>Esperanza</td>
                  <td>Botello</td>
                  <td>Finance and Accounting</td>
                  <td>espe****@genemex.com.mx</td>
                  <td></td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>GENEMEX - ANUNCIOS GENERAL NEON DE MEXICO, S.A. DE C.V.</td>
                  <td>Luis García</td>
                  <td>Franco</td>
                  <td>Finance and Accounting</td>
                  <td>g.**@genemex.com.mx</td>
                  <td></td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>GENEMEX - ANUNCIOS GENERAL NEON DE MEXICO, S.A. DE C.V.</td>
                  <td>Rene Esquivel</td>
                  <td>Vargas</td>
                  <td>Sales and Business Development</td>
                  <td>esqu****@genemex.com.mx</td>
                  <td></td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>GEOMARKETING</td>
                  <td>Alicia</td>
                  <td>Rosas Vázquez</td>
                  <td>Consulting</td>
                  <td>ali***@geomarketing.mx</td>
                  <td>Consulting</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>GEOMARKETING</td>
                  <td>Gabriel</td>
                  <td>Nolasco</td>
                  <td>Marketing</td>
                  <td>gabr****@geomarketing.mx</td>
                  <td>Consulting</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>GEOMARKETING</td>
                  <td>Jorge</td>
                  <td>Castilla</td>
                  <td>Operations and Logistics</td>
                  <td>jorg****@geomarketing.mx</td>
                  <td>Consulting</td>
                  <td>+525****</td>
                </tr>
                <tr className="in-shadow ">
                  <td>Raloy</td>
                  <td>Ivan</td>
                  <td>Ramirez Cruz</td>
                  <td>Support and Assistant</td>
                  <td>ir**@raloy.com.mx</td>
                  <td>Oil &amp; Gas</td>
                  <td>+527****</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="banner-overlay banner-overlay-gradient"></div>
          <div className="banner-content">
            <div className="tachometers-ul tachometers-ul-large first-tach text-center">
              <div className="tachometer-li">
                <div className="t-value active" data-size="180" data-value="1" data-total="69,049" data-thickness="10">
                  <div className="t-value-inner">69,049</div>
                </div>
                <h6 className="t-title">Direcciones de correo electrónico válidas</h6>

                {secondaryNavigation.free_trial?.slug && (
                  <Link
                    route={secondaryNavigation.free_trial.slug}
                    className="btn-white btn-lg open-sample tachometer-button"
                  >
                    DESCARGUE UNA MUESTRA
                  </Link>
                )}
              </div>
              <div className="tachometer-li">
                <div className="t-value active" data-size="180" data-value="1" data-total="2" data-thickness="10">
                  <div className="t-value-inner">2</div>
                </div>
                <h6 className="t-title">Promedio de contactos de correo electrónico por compañía</h6>

                {secondaryNavigation.pricing?.slug && (
                  <Link route={secondaryNavigation.pricing.slug} className="btn-white btn-lg tachometer-button">
                    COMPRAR AHORA
                  </Link>
                )}
              </div>
              <div className="tachometer-li">
                <div className="t-value active" data-size="180" data-value="1" data-total="90%" data-thickness="10">
                  <div className="t-value-inner">90%</div>
                </div>
                <h6 className="t-title">Tasa de precisión</h6>
                {secondaryNavigation.book_demo?.slug && (
                  <Link route={secondaryNavigation.book_demo.slug} className="btn-white btn-lg tachometer-button">
                    DEMOSTRACIÓN GRATUITA
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper">
          <div className="section-heading">
            <div className="h-icon">
              <img src="/proxy/lead/img/header-icon-phone.png" alt="Base de datos de números telefónicos en México" />
            </div>
            <h2>Base de datos de números telefónicos en México</h2>
            <p>
              Con acceso a m&aacute;s de 278,187 n&uacute;meros directos en M&eacute;xico, su equipo de ventas puede
              saltarse a los guardianes para ponerse en contacto con las personas facultadas a tomar importantes
              decisiones de negocios de sus empresas. Nuestra plataforma en l&iacute;nea incluso facilita y agiliza la
              tarea de encontrar CEO, CTO y altos directivos gracias a nuestros filtros de nivel de antig&uuml;edad de
              personal, para que as&iacute; se pueda dirigir a ellos directamente los que est&aacute;n en la parte
              superior de la cadena.
            </p>
          </div>
          <div className="tachometers-ul second-tach text-center">
            <div className="tachometer-li">
              <div className="t-value" data-size="180" data-value="1" data-total="278,187" data-thickness="5">
                <div className="t-value-inner">278,187</div>
              </div>
              <h6 className="t-title">Número de compañías en España</h6>

              {secondaryNavigation.free_trial?.slug && (
                <Link route={secondaryNavigation.free_trial.slug} className="btn-blue btn-lg open-sample">
                  DESCARGUE UNA MUESTRA
                </Link>
              )}
            </div>
            <div className="tachometer-li">
              <div className="t-value" data-size="180" data-value="1" data-total="264,277" data-thickness="5">
                <div className="t-value-inner">264,277</div>
              </div>
              <h6 className="t-title">Número de teléfono directos enumerados</h6>

              {secondaryNavigation.pricing?.slug && (
                <Link route={secondaryNavigation.pricing.slug} className="btn-blue btn-lg button-primary button-md">
                  COMPRAR AHORA
                </Link>
              )}
            </div>
            <div className="tachometer-li">
              <div className="t-value" data-size="180" data-value="1" data-total="1" data-thickness="5">
                <div className="t-value-inner">1</div>
              </div>
              <h6 className="t-title">Número de teléfono promedio por empresa</h6>
              {secondaryNavigation.book_demo?.slug && (
                <Link route={secondaryNavigation.book_demo.slug} className="btn-green btn-lg button-md">
                  DEMOSTRACIÓN GRATUITA
                </Link>
              )}
            </div>
          </div>
        </div>
        <div className="section-banner banner-white">
          <div className="banner-img banner-free-sample"></div>
          <div className="banner-overlay banner-overlay-gradient"></div>
          <div className="banner-content">
            <div className="wrapper">
              <h2>Descargue una lista de muestra</h2>
              <p>
                Estamos 100% seguros de que se impresionar&aacute; con la calidad de la informaci&oacute;n de nuestra
                compa&ntilde;&iacute;a; as&iacute; que lo invitamos a verificar nuestra precisi&oacute;n. Para descargar
                una lista de correos electr&oacute;nicos de mercadeo gratuita, solo haga clic en el bot&oacute;n de
                abajo, llene el formulario, y disfrute de su informaci&oacute;n de contactos gratis para M&eacute;xico
                inmediatamente.
              </p>
              <div>
                {secondaryNavigation.free_trial?.slug && (
                  <Link route={secondaryNavigation.free_trial.slug} className="btn-transparent btn-lg open-sample">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                      <path d="M19 15.15a.942.942 0 0 0-1.32 0h-.006l-2.744 2.39V8.4a.933.933 0 1 0-1.866 0v9.14l-2.763-2.46a.939.939 0 1 0-1.251 1.4l4.256 3.73a1.088 1.088 0 0 0 1.382 0l4.256-3.73a.936.936 0 0 0 .062-1.32L19 15.15zM14 28a14 14 0 1 1 14-14 14 14 0 0 1-14 14zm0-26.14A12.135 12.135 0 1 0 26.133 14 12.139 12.139 0 0 0 14 1.86z" />
                    </svg>
                    <span>Descargar datos</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="platform">
          <div className="wrapper">
            <h2 className="text-center">México Base de datos de marketing B2B</h2>
            <div className="clearfix">
              <div className="col-sm-5 platform-text">
                <p>
                  Global Database puede proporcionar a su equipo de ventas exactamente los tipos de contactos que
                  necesitan para lanzar sus productos, con una gama de filtros basados en preferencias
                  demogr&aacute;ficas. Nuestra plataforma online incluso facilita y agiliza la b&uacute;squeda de CEOs,
                  CTOs y altos directivos de la compa&ntilde;&iacute;a a trav&eacute;s de nuestro filtro personal de
                  nivel de antig&uuml;edad, para que pueda apuntar a aquellos directamente en la parte superior de la
                  cadena.
                  <br />
                  &nbsp;
                </p>
                <h3>Reserve una demostración de 5 minutos</h3>
                <p>Solicite una demostración gratuita y vea el potencial usted mismo.</p>
                <div className="buttons-group">
                  {secondaryNavigation.free_trial?.slug && (
                    <Link route={secondaryNavigation.free_trial.slug} className="btn-green btn-lg open-sample">
                      DESCARGUE UNA MUESTRA
                    </Link>
                  )}

                  {secondaryNavigation.book_demo?.slug && (
                    <Link route={secondaryNavigation.book_demo.slug} className="btn-blue btn-lg">
                      DEMOSTRACIÓN GRATUITA
                    </Link>
                  )}
                </div>
              </div>
              <div className="col-sm-7">
                <img src="/proxy/lead/img/banner-compare2.jpg" alt="México Base de datos de marketing B2B" />
              </div>
            </div>
          </div>
        </div>

        <div className="benefits">
          <div className="wrapper">
            <h3>
              <span>Nuestros beneficios</span>
            </h3>
            <ul>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="37" viewBox="0 0 55.625 62">
                  <path
                    d="M595.248,10308l-0.65-.3a48.223,48.223,0,0,1-15.353-11.3,42.93,42.93,0,0,1-4.071-5.5,49.123,49.123,0,0,1-6.6-17.2,74.989,74.989,0,0,1-1.188-12.7l-0.012-5.5,1.323-.1a53.248,53.248,0,0,0,16.941-4c1.427-.6,2.775-1.2,4.125-1.9,1.286-.7,2.563-1.6,3.69-2.3l1.91-1.2,0.745,0.5a46.482,46.482,0,0,0,18.529,8,34.465,34.465,0,0,0,4.77.6l0.854,0.1c0.527,0.1.971,0.1,1.416,0.2l1.327,0.2-0.04,1.5c-0.239,10.5-2.086,19.5-5.644,27.3a51.2,51.2,0,0,1-21.529,23.2Zm-25.674-50.2,0.006,3.2a72.383,72.383,0,0,0,1.14,12.2,47.556,47.556,0,0,0,6.239,16.3,38.589,38.589,0,0,0,3.83,5.1,44.943,44.943,0,0,0,14.322,10.6c9.293-5.5,16.094-12.8,20.265-21.9,3.312-7.3,5.074-15.7,5.377-25.5a1.7,1.7,0,0,1-.687-0.1l-0.865-.1a37.539,37.539,0,0,1-4.913-.6,49.944,49.944,0,0,1-18.97-8.1l-0.761.5c-1.19.7-2.5,1.6-3.852,2.3-1.409.8-2.819,1.4-4.306,2.1A53.111,53.111,0,0,1,569.574,10257.8Zm25.322,41.9-0.227-.1a39.6,39.6,0,0,1-10.752-8.5,41.1,41.1,0,0,1-3.44-4.6,42.458,42.458,0,0,1-5.618-14.8,61.942,61.942,0,0,1-1-8.8l-0.022-.5,0.426-.1a60.267,60.267,0,0,0,13.569-3.9,40.544,40.544,0,0,0,5.008-2.4,20.174,20.174,0,0,0,2.235-1.3l0.224-.1,0.223,0.1a53.581,53.581,0,0,0,18.686,7.3l1.394,0.3,0.637,0.1-0.054.5a56.237,56.237,0,0,1-4.624,17.8,44.76,44.76,0,0,1-16.442,18.9Zm-20.071-36.4a62.317,62.317,0,0,0,.96,8.2,40.588,40.588,0,0,0,5.461,14.3,32.674,32.674,0,0,0,3.341,4.5,37.326,37.326,0,0,0,10.27,8.2,43.448,43.448,0,0,0,15.86-18.3,54.65,54.65,0,0,0,4.466-16.9c-0.375-.1-0.752-0.1-1.129-0.2a53.941,53.941,0,0,1-18.761-7.3c-0.665.4-1.346,0.8-2.049,1.2a41.687,41.687,0,0,1-5.089,2.4A58.78,58.78,0,0,1,574.825,10263.3Zm30.374,9.7-12.131,10a2.635,2.635,0,0,1-3.675-.3l-4.359-5.2a1.574,1.574,0,0,1,.026-2,1.373,1.373,0,0,1,.851-0.4,1.129,1.129,0,0,1,.869.5l4.587,5.4,12.4-10.3a1.177,1.177,0,0,1,1.7.3A1.617,1.617,0,0,1,605.2,10273Z"
                    transform="translate(-567.375 -10246)"
                  />
                </svg>
                <p>Evite guardias con nuestros correos electrónicos directos y directorios telefónicos</p>
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="27" viewBox="0 0 60 52">
                  <path
                    d="M953.046,10275.5v-13.7a1.345,1.345,0,0,0-1.385-1.3,1.33,1.33,0,0,0-1.324,1.3v14.7l5.958,6.7a1.391,1.391,0,0,0,1.024.4,0.993,0.993,0,0,0,.9-0.3,1.262,1.262,0,0,0,.121-1.9Zm31.415-5.2a1.422,1.422,0,0,0-1.926.1l-4.152,5.2c-0.181-14.2-12.1-25.6-26.722-25.6-14.684,0-26.661,11.7-26.661,26s11.977,26,26.661,26a1.345,1.345,0,0,0,1.385-1.3,1.365,1.365,0,0,0-1.385-1.4c-13.18,0-23.953-10.4-23.953-23.3s10.773-23.4,23.953-23.4c12.94,0,23.472,10,23.953,22.4l-3.671-4.6a1.422,1.422,0,0,0-1.926-.1,1.244,1.244,0,0,0-.18,1.8l6.319,7.9a1.53,1.53,0,0,0,1.083.5,1.429,1.429,0,0,0,1.084-.5l6.379-7.9A1.2,1.2,0,0,0,984.461,10270.3Z"
                    transform="translate(-925 -10250)"
                  />
                </svg>
                <p>Tener acceso a una suscripción de 12 meses con actualizaciones constantes </p>
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="37" viewBox="0 0 62 60">
                  <path
                    d="M1315.21,10246a1.214,1.214,0,0,0-1.27,1.2v9.6a1.277,1.277,0,0,0,2.55,0v-9.6A1.217,1.217,0,0,0,1315.21,10246Zm29.52,29H1335a1.28,1.28,0,0,0-1.27,1.2,1.3,1.3,0,0,0,1.27,1.3h9.73a1.3,1.3,0,0,0,1.27-1.3A1.28,1.28,0,0,0,1344.73,10275Zm-29.51,18.9a1.3,1.3,0,0,0-1.28,1.3v9.5a1.275,1.275,0,1,0,2.55,0v-9.5A1.3,1.3,0,0,0,1315.22,10293.9ZM1295,10275h-9.73a1.28,1.28,0,0,0-1.27,1.2,1.3,1.3,0,0,0,1.27,1.3H1295a1.3,1.3,0,0,0,1.27-1.3A1.28,1.28,0,0,0,1295,10275Zm38.86-17.2a26.056,26.056,0,0,0-15.42-7.5v2.5a23.753,23.753,0,0,1,13.61,6.8,22.957,22.957,0,0,1,6.65,13.5h2.55A25.665,25.665,0,0,0,1333.86,10257.8Zm-42.49,21.6h-2.56a26.19,26.19,0,0,0,23.19,22.3v-2.5A23.72,23.72,0,0,1,1291.37,10279.4Zm5.15-21.9a25.429,25.429,0,0,0-7.77,15.6h2.56a23.171,23.171,0,0,1,6.99-13.9,24.468,24.468,0,0,1,13.7-6.5v-2.5A26.775,26.775,0,0,0,1296.52,10257.5Zm42.11,21.9a23.787,23.787,0,0,1-20.19,19.8v2.5a26.219,26.219,0,0,0,22.75-22.3h-2.56Zm-24.41-12.3v-2.9h1.8v2.7a13.518,13.518,0,0,1,2.05.4,8.964,8.964,0,0,1,1.56.6,0.245,0.245,0,0,1,.12.2c-0.22.6-.46,1.2-0.7,1.8a6.152,6.152,0,0,0-2.24-.8,4.534,4.534,0,0,0-2.82.1,2.3,2.3,0,0,0-1.72,1.9,2.149,2.149,0,0,0,1,2.3,18.016,18.016,0,0,0,2.25,1.1,24.706,24.706,0,0,1,2.9,1.5,4.5,4.5,0,0,1,2.02,4.6,4.561,4.561,0,0,1-3.07,3.7,7.617,7.617,0,0,1-1.53.5v2.9h-1.92v-2.8a12.259,12.259,0,0,1-1.94-.3,6.359,6.359,0,0,1-2.31-.8,0.279,0.279,0,0,1-.14-0.4c0.21-.5.39-1.1,0.59-1.6,0.16,0.1.3,0.1,0.44,0.2a7.928,7.928,0,0,0,3.98,1,4.125,4.125,0,0,0,1.56-.3,2.79,2.79,0,0,0,.63-4.9,11.124,11.124,0,0,0-2.46-1.3,11.575,11.575,0,0,1-3.03-1.6,4.31,4.31,0,0,1,.22-6.7,6.767,6.767,0,0,1,2.37-1.1h0.39Zm0.78,24.3a15.453,15.453,0,1,1,15.74-15.4A15.584,15.584,0,0,1,1315,10291.4Zm0-29.9a14.5,14.5,0,1,0,14.77,14.5A14.653,14.653,0,0,0,1315,10261.5Z"
                    transform="translate(-1284 -10246)"
                  />
                </svg>
                <p>Filtre, ordene y oriente prospectos adaptados a sus necesidades </p>
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="39" height="26" viewBox="0 0 66 44">
                  <path
                    d="M563.294,10518.8h8.7a10.6,10.6,0,0,0-.746,3.9,1.309,1.309,0,0,0,1.3,1.3h44.918a1.309,1.309,0,0,0,1.3-1.3,10.617,10.617,0,0,0-.746-3.9h8.7a1.308,1.308,0,0,0,1.294-1.3c0-9.2-12.3-12.8-15.149-13.5v-1.7a14.436,14.436,0,0,0,1.832-3.4,1.756,1.756,0,0,0,1.417-.8c0.777-1.1,1.346-5.5.658-6.5a1.458,1.458,0,0,0-.531-0.5c0.183-2.4-.048-5.8-2.2-8.2-1.68-2-4.2-2.9-7.48-2.9a10.067,10.067,0,0,0-6.483,1.9,14.714,14.714,0,0,0-10.134,0,10.067,10.067,0,0,0-6.483-1.9c-3.284,0-5.8.9-7.48,2.9-2.15,2.4-2.38,5.8-2.2,8.2a1.466,1.466,0,0,0-.531.5c-0.688,1-.118,5.4.659,6.5a1.752,1.752,0,0,0,1.416.8,14.471,14.471,0,0,0,1.831,3.4v1.7c-2.843.7-15.148,4.3-15.148,13.5A1.308,1.308,0,0,0,563.294,10518.8Zm43.256-36.3c2.5,0,4.352.7,5.518,2,2,2.3,1.675,6.1,1.443,7.6a1.358,1.358,0,0,0,.464,1.2,0.987,0.987,0,0,0,.514.2,16.333,16.333,0,0,1-.317,2.6,0.82,0.82,0,0,0-.685,0,1.193,1.193,0,0,0-.876.8,11.267,11.267,0,0,1-2.043,4.1,1.153,1.153,0,0,0-.3.8v2.6a2.082,2.082,0,0,0,1.153,1.8,0.4,0.4,0,0,0,.322.1c0.129,0.1,12.24,2.8,13.557,9.9h-8.7c-4.034-5.5-12.52-7.9-14.723-8.5v-2a15.3,15.3,0,0,0,2.083-3.9,1.837,1.837,0,0,0,1.564-.9c0.847-1.1,1.476-5.9.73-7a1.58,1.58,0,0,0-.623-0.5c0.216-2.7-.015-6.5-2.406-9.2-0.239-.3-0.5-0.5-0.767-0.8A8.337,8.337,0,0,1,606.55,10482.5Zm-11.55,1.1c2.826,0,4.932.7,6.26,2.3,2.267,2.6,1.9,6.8,1.643,8.5a1.358,1.358,0,0,0,.464,1.2c0.184,0.1.4,0.2,0.627,0.3a16.711,16.711,0,0,1-.395,3.1,1.177,1.177,0,0,0-.827,0,1.193,1.193,0,0,0-.877.8,12.416,12.416,0,0,1-2.306,4.6,1.157,1.157,0,0,0-.3.8v2.8a2.385,2.385,0,0,0,1.2,2c0.1,0,.21.1,0.323,0.1,0.146,0,13.929,3.1,15.251,11.3H573.936c1.322-8.2,15.105-11.3,15.251-11.3,0.113,0,.222-0.1.323-0.1a2.385,2.385,0,0,0,1.2-2v-2.8a1.152,1.152,0,0,0-.3-0.8,12.446,12.446,0,0,1-2.306-4.6,1.193,1.193,0,0,0-.877-0.8,1.169,1.169,0,0,0-.824,0,16.46,16.46,0,0,1-.4-3.1c0.226-.1.443-0.2,0.627-0.3a1.363,1.363,0,0,0,.463-1.2c-0.26-1.7-.624-5.9,1.643-8.5C590.068,10484.3,592.174,10483.6,595,10483.6Zm-16.738,22.7a0.4,0.4,0,0,0,.322-0.1,2.081,2.081,0,0,0,1.152-1.8v-2.6a1.153,1.153,0,0,0-.3-0.8,11.251,11.251,0,0,1-2.043-4.1,1.19,1.19,0,0,0-.876-0.8,0.808,0.808,0,0,0-.68,0,16.1,16.1,0,0,1-.321-2.6,0.981,0.981,0,0,0,.513-0.2,1.356,1.356,0,0,0,.464-1.2c-0.232-1.5-.555-5.3,1.444-7.6,1.166-1.3,3.022-2,5.517-2a8.337,8.337,0,0,1,4.1.9c-0.27.3-.528,0.5-0.767,0.8-2.391,2.7-2.622,6.5-2.406,9.2a1.573,1.573,0,0,0-.623.5c-0.746,1.1-.117,5.9.732,7a1.832,1.832,0,0,0,1.562.9,15.3,15.3,0,0,0,2.084,3.9v2c-2.2.6-10.689,3-14.723,8.5h-8.7C566.02,10509.1,578.132,10506.4,578.262,10506.3Z"
                    transform="translate(-562 -10480)"
                  />
                </svg>
                <p>Ideal para el seguimiento de la competencia y para asegurar nuevos clientes, socios o proveedores</p>
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="36" viewBox="0 0 62 60">
                  <path
                    d="M986,10483.5H965.133v-4a7.567,7.567,0,0,0-7.7-7.5h-4.858a7.568,7.568,0,0,0-7.706,7.5v4H924v19.7h1.49v23.8a5.052,5.052,0,0,0,5.145,5h48.733a5.247,5.247,0,0,0,3.634-1.5,4.8,4.8,0,0,0,1.5-3.5v-23.8H986v-19.7Zm-37.189-7.7a5.532,5.532,0,0,1,3.763-1.5h4.858a5.533,5.533,0,0,1,3.762,1.5,5,5,0,0,1,1.558,3.7v4h-15.5v-4A5,5,0,0,1,948.808,10475.8Zm-22.424,10h57.228v15h-9.835v-4H962.451v4h-14.9v-4H936.222v4h-9.838v-15Zm45.009,16.2h-6.558v-2.9h6.558v2.9Zm-6.558,2.3h6.558v4h-6.558v-4Zm-19.671-2.3h-6.558v-2.9h6.558v2.9Zm-6.558,2.3h6.558v4h-6.558v-4Zm43.516,22.7a2.72,2.72,0,0,1-2.754,2.7H930.635a2.741,2.741,0,0,1-1.952-.8,2.559,2.559,0,0,1-.808-1.9v-23.8h8.347v7.5h11.326v-7.5h14.9v7.5h11.326v-7.5h8.345v23.8Z"
                    transform="translate(-924 -10472)"
                  />
                </svg>
                <p>Descargue listas segmentadas de alta calidad basadas en +20 criterios de búsqueda</p>
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="37" viewBox="0 0 60.29 64.3">
                  <path
                    d="M1344.71,10498.1l-5.96-5.6v-10.6a0.907,0.907,0,0,0-.92-0.9h-11.07l-11.12-10.6a0.833,0.833,0,0,0-1.28,0l-11.12,10.6h-11.07a0.907,0.907,0,0,0-.92.9v10.6l-5.96,5.6a1.177,1.177,0,0,0-.29.7v34.4a0.909,0.909,0,0,0,.93.9h58.14a0.907,0.907,0,0,0,.92-0.9v-34.4A1.16,1.16,0,0,0,1344.71,10498.1Zm-51.62-5.3v-10h43.81v21.6l-21.9,20.9-21.91-20.9v-11.6Zm-6.24,7.7,20.39,19.5-20.39,12v-31.5Zm1.72,31.8,19.51-11.6,6.53,6.3a0.48,0.48,0,0,0,.78,0l6.35-6.1,19.63,11.4h-52.8Zm54.58-.3-20.59-11.9,20.59-19.6v31.5Z"
                    transform="translate(-1284.84 -10469.95)"
                  />
                </svg>
                <p>
                  Aumente la tasa de éxito de sus campañas de correo electrónico con una lista de correos electrónicos
                  precisa y actualizada
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className=" latest-news">
          <div className="wrapper">
            <div className="row">
              <div className="col-sm-6">
                <h3>Lo último de nuestro blog</h3>
              </div>
              <div className="col-sm-6 text-right">
                {secondaryNavigation.blog?.slug && (
                  <Link
                    route={secondaryNavigation.blog.slug}
                    query={{ paage: 1, type: 'top_gdb_companies' }}
                    className="btn-blue-grad"
                  >
                    Ver todo el blog
                  </Link>
                )}
              </div>
            </div>
            <ul className="view-mode grid">
              <li>
                {}
                <a href={`${process.env.HOST || ''}/es/las-25-mejores-companias-de-mexico-por-ingresos-en-el-2017`}>
                  <span
                    className="middle-img"
                    style={{ backgroundImage: 'url(/proxy/lead/upload/96-5c74172ef0ce3.jpg)' }}
                  >
                    <img
                      src="/proxy/lead/upload/96-5c74172ef0ce3.jpg"
                      alt="Las 25 empresas más importantes de México por ingresos en el 2017"
                    />
                  </span>
                  <span className="list-cont">
                    <small>25.02.2019</small>
                    <span className="list-title">
                      Las 25 empresas más importantes de México por ingresos en el 2017
                    </span>
                    <span className="list-info">
                      Directorio de Empresas más importantes en Mexico, la deuda del sector público disminuyó después de
                      un drástico y continuo crecimiento durante los últimos 12 años, alcanzando un máximo en 2016. La
                      deuda pública del país comenzó con un 37% en el 2005 a un 58% del PIB en 2016 regresando al 54% en
                      el 2018.
                    </span>
                  </span>
                </a>
              </li>
              <li>
                {}
                <a href={`${process.env.HOST || ''}/es/las-35-mejores-companias-espanolas-por-ingresos-en-el-2017`}>
                  <span className="middle-img" style={{ backgroundImage: 'url(/proxy/lead/upload/84.gif)' }}>
                    <img
                      src="/proxy/lead/upload/84.gif"
                      alt="Las 35 mejores compañías españolas por ingresos en el 2017"
                    />
                  </span>
                  <span className="list-cont">
                    <small>08.11.2018</small>
                    <span className="list-title">Las 35 mejores compañías españolas por ingresos en el 2017</span>
                    <span className="list-info">
                      Con una amplia gama de áreas de negocios floreciendo en toda España, existe un potencial de
                      negocios impresionante disponible. Sea cual sea el área en el que se esté enfocando, puede ser de
                      gran interés, saber cuáles son las organizaciones con mayores ingresos anuales en la actualidad.
                    </span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="our-customers">
          <div className="wrapper">
            <h2>Empresas que confían en Global Database </h2>
            <ul>
              <li>
                <img src="/proxy/lead/img/customers/1.png" alt="Microsoft" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/2.png" alt="Avaya" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/26.png" alt="Oracle" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/4.png" alt="KPMG" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/5.png" alt="Maserati" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/6.png" alt="Frost and sullivan award" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/7.png" alt="DHL" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/8.png" alt="Caterpillar" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/9.png" alt="Du pont" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/10.png" alt="Iveco" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/11.png" alt="Ipsos" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/12.png" alt="Motorola" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/13.png" alt="Experian" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/14.png" alt="Sacci" />
              </li>
              <li>
                <img src="/proxy/lead/img/customers/15.png" alt="Board of Investment Mauritius" />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="book-content">
        <h3 className="no-margin">Solicite una demostración sin compromiso para ver exactamente lo que ofrecemos</h3>
        <h3>Déjenos mostrarle que tan simple y poderosa es nuestra base de datos</h3>
        <div className="buttons-group">
          {secondaryNavigation.book_demo?.slug && (
            <Link route={secondaryNavigation.book_demo.slug} className="btn-blue btn-lg">
              DEMOSTRACIÓN GRATUITA
            </Link>
          )}

          {secondaryNavigation.pricing?.slug && (
            <Link route={secondaryNavigation.pricing.slug} className="btn-blue btn-lg">
              COMPRAR AHORA
            </Link>
          )}

          {secondaryNavigation.free_trial?.slug && (
            <Link route={secondaryNavigation.free_trial.slug} className="btn-green btn-lg open-sample">
              DESCARGUE UNA MUESTRA
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default MexicoPage;
